const configLogProvider = $logProvider => {
	$logProvider.debugEnabled(true);
};
configLogProvider.$inject = ['$logProvider'];
export default configLogProvider;
